export default "__VITE_PUBLIC_ASSET__21b3e2f6__"